import { useAccountService } from './accountService';
import { useAuthService } from './authService';
import { useBabylonService } from './babylonService';
import { useGeoRecordCategoryService } from './geoRecordCategoryService';
import { useGeoRecordCategoryCustomLayerService } from './geoRecordCategoryCustomLayerService';
import { useGeoRecordCategoryIconService } from './geoRecordCategoryIconService';
import { useGeoRecordModelService } from './geoRecordModelService';
import { useGeoRecordStatusService } from './geoRecordStatusService';
import { useCourseMeasurementService } from './courseMeasurementService';
import { useCourseSchemaService } from './courseSchemaService';
import { useGddService } from './gddService';
import { useGddProductService } from './gddProductService';
import { useGeoRecordHistoryService } from './geoRecordHistoryService';
import { useMapboxService } from './mapboxService';
import { useMeasureRecordService } from './measureRecordService';
import { useOrganizationService } from './organizationService';
import { useAppNotificationService } from './appNotificationService';
import { usePermissionService } from './permissionService';
import { usePinzoneCategoryService } from './pinzoneCategoryService';
import { usePinzoneService } from './pinzoneService';
import { usePostgisService } from './postgisService';
import { useProjectService } from './projectService';
import { useRemoteLoginMappingService } from './remoteLoginMappingService';
import { useRoleService } from './roleService';
import { useRoundService } from './roundService';
import { useScreenshotService } from './screenshotService';
import { useImgTournamentService } from './imgTournamentService';
import { useWeatherService } from './weatherService';
import { useGeoRecordService } from './geoRecordService';
import { useGeoRecordCommentService } from './geoRecordCommentService';
import { useGeoRecordImageService } from './geoRecordImageService';
import { useFeatureService } from './featureService';
import { useDuplicateSerice } from './duplicateService';
import { useEventLogService } from './eventLogService';
import { useFeedbackService } from './feedbackService';
import { useGeoRecordProjectService } from './geoRecordProjectServices';
import { useUserSettingService } from './userSettingsService';
import { useRenderSelectionService } from './renderSelectionService';
import { useAdminDashboardService } from './adminDashboardService';
import { useTrackingService } from './buggyTrackingService';
import { useEuropeTourService } from './europeTourServices';
import { useGeoRecordEventService } from './geoRecordArchiveService';
import { useWHSTeeParamsService } from './whsTeeParamsService';
import { useWHSWhitelabelSiteService } from './whsWhitelabelSiteService';
import { useTutorialVideoService } from './tutorialVideoService';
import { useNotificationService } from './notificationService';
import { usePinzoneTableService } from './pinzoneTableService';
import { useAppPushNotificationService } from './appPushNotificationService';
import { usePinzoneExternalEmbedSiteService } from './pinzoneExternalEmbedService';
import { usePublicInfoService } from './publicInfoService';
import { useGeoRecordDeleteRequestService } from './geoRecordDeleteRequestService';


export const useService = () => {
    return {
        ...useAccountService(),
        ...useAuthService(),
        ...useBabylonService(),
        ...useGeoRecordCategoryService(),
        ...useGeoRecordCategoryCustomLayerService(),
        ...useGeoRecordCategoryIconService(),
        ...useGeoRecordImageService(),
        ...useGeoRecordModelService(),
        ...useGeoRecordStatusService(),
        ...useCourseMeasurementService(),
        ...useCourseSchemaService(),
        ...useGddService(),
        ...useGddProductService(),
        ...useGeoRecordHistoryService(),
        ...useMapboxService(),
        ...useMeasureRecordService(),
        ...useOrganizationService(),
        ...useAppNotificationService(),
        ...usePinzoneCategoryService(),
        ...usePinzoneService(),
        ...usePermissionService(),
        ...usePostgisService(),
        ...useProjectService(),
        ...useRemoteLoginMappingService(),
        ...useRoleService(),
        ...useRoundService(),
        ...useScreenshotService(),
        ...useImgTournamentService(),
        ...useWeatherService(),
        ...useGeoRecordService(),
        ...useGeoRecordCommentService(),
        ...useFeatureService(),
        ...useDuplicateSerice(),
        ...useEventLogService(),
        ...useGeoRecordModelService(),
        ...useFeedbackService(),
        ...useGeoRecordProjectService(),
        ...useUserSettingService(),
        ...useRenderSelectionService(),
        ...useAdminDashboardService(),
        ...useTrackingService(),
        ...useEuropeTourService(),
        ...useGeoRecordEventService(),
        ...useWHSTeeParamsService(),
        ...useWHSWhitelabelSiteService(),
        ...useTutorialVideoService(),
        ...useNotificationService(),
        ...usePinzoneTableService(),
        ...useAppPushNotificationService(),
        ...usePinzoneExternalEmbedSiteService(),
        ...usePublicInfoService(),
        ...useGeoRecordDeleteRequestService(),
    };
};
